import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=2096e49a&scoped=true"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"
import style0 from "./logs.vue?vue&type=style&index=0&id=2096e49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096e49a",
  null
  
)

export default component.exports